import { ActivityPlayerApi, AssetRegistryProvider } from "@cca/components";
import * as React from "react";

export type ActivityPlayerProps = {
  children: React.ReactNode;
};

export const ActivityPlayer = React.forwardRef<
  ActivityPlayerApi,
  ActivityPlayerProps
>(function ActivityPlayer({ children }, ref) {
  return <AssetRegistryProvider ref={ref}>{children}</AssetRegistryProvider>;
});
